import { InjectableClass } from '@fino/lib-injection';

export class ConfirmReceivingService extends InjectableClass {
  constructor(ticketService, $q) {
    'ngInject';
    super({ ticketService, $q });
  }

  getWarrantUrl(ticketId) {
    return this.ticketService.getWarrantUrl(ticketId);
  }

  confirmRequest(data) {
    return this.$q.when(data);
  }
}
